import { VIconButton } from '../VIconButton';
import { KeyboardArrowLeft, KeyboardArrowRight } from '../asset';
import { useDateNavigation, useVPeriodSelectorContext } from './hook';

const VDateNavigationButton = ({
  Icon,
  onClick,
  disabled = false,
}: {
  onClick: () => void;
  Icon: ReactSVGComponent;
  disabled?: boolean;
}) => {
  return (
    <VIconButton
      Icon={Icon}
      size="sm"
      variant="roundPrimary"
      onClick={onClick}
      disabled={disabled}
    />
  );
};

export const VDateNavigationPrevButton = () => {
  const { dateRangeValue, periodUnitValue, onDateRangeChange } =
    useVPeriodSelectorContext();
  const { navigateDateRange } = useDateNavigation();

  const onClick = () => {
    onDateRangeChange(
      navigateDateRange(dateRangeValue, periodUnitValue, 'prev'),
    );
  };

  return <VDateNavigationButton Icon={KeyboardArrowLeft} onClick={onClick} />;
};

export const VDateNavigationNextButton = () => {
  const { dateRangeValue, periodUnitValue, onDateRangeChange } =
    useVPeriodSelectorContext();
  const { navigateDateRange, canNavigateNext } = useDateNavigation();

  const onClick = () => {
    onDateRangeChange(
      navigateDateRange(dateRangeValue, periodUnitValue, 'next'),
    );
  };
  const disabled = !canNavigateNext(dateRangeValue, periodUnitValue);

  return (
    <VDateNavigationButton
      Icon={KeyboardArrowRight}
      onClick={onClick}
      disabled={disabled}
    />
  );
};
